/**
 * @example authService.login(data).then(...);
 * @example authService.register(data).then(...);
 */
export default class {

    /** @ngInject */
    constructor($rootScope, events, requestService) {
        this.urlBase = requestService.urlBase;
        this.authenticated = undefined; // We need to ask the server first.
        this.$rootScope = $rootScope;
        this.events = events;
        this.request = requestService.request;
    }

    setAuthenticated(authenticated=true) {
        this.$rootScope.$emit(this.events.authChange, authenticated);
        this.authenticated = authenticated;
    }

    register(data) {
        // data: first_name, last_name, email, password1, password2, newsletter
        return this.request('POST', `${this.urlBase}/registration`, data);
    }

    login(data) {
        // data: email, password
        return this.request('POST', `${this.urlBase}/login`, data)
            .then(() => this.setAuthenticated(true));
    }

    logout() {
        return this.request('POST', `${this.urlBase}/logout`)
            .finally(() => this.setAuthenticated(false));
    }

    changePassword(data) {
        // data: new_password1, new_password2
        return this.request('POST', `${this.urlBase}/password/change`, data);
    }

    resetPassword(data) {
        // data: email
        return this.request('POST', `${this.urlBase}/password/reset`, data);
    }

    verify(data) {
        // data: key
        return this.request('POST', `${this.urlBase}/registration/verify-email`, data);
    }

    isEmailRegistered(data) {
        // data: email
        return this.request('POST', `${this.urlBase}/email`, data);
    }

    resendEmailConfirmation(data) {
        // data: email
        return this.request('POST', `${this.urlBase}/email/confirmation`, data);
    }

    confirmReset(data) {
        // data: uid, token, password1, password2
        return this.request('POST', `${this.urlBase}/password/reset/confirm`, data)
            .then(() => this.setAuthenticated(true));
    }

    activate(data) {
        //data: key, password1, password2
        return this.request('POST', `${this.urlBase}/activation/managed`, data)
            .then(() => this.setAuthenticated(true));
    }

    resendActivationEmail(data) {
        // data: email
        return this.request('POST', `${this.urlBase}/activation/managed/resend`, data);
    }

    checkPermissions(data) {
        // data: {permissions: []}
        return this.request('POST', `${this.urlBase}/user/check_permissions`, data);
    }
}



// WEBPACK FOOTER //
// ./auth/auth-service.js